import { ContactAddress, Organization } from 'domains/orgDomain';
import { PlatformRoleEnum, SiteRoleEnum } from './roleDomain';

export interface LoginForm {
  username: string;
  password: string;
}

export interface EmailOtpRequestPayload {
  email: string;
}

export interface EmailOtpVerifyPayload {
  email: string;
  code: string;
}

export interface EmailOtpRequestResponse {
  requested: boolean;
  expiresInSeconds: number;
  resendAvailableInSeconds: number;
}

export interface EmailOtpVerifyResponse {
  token: string;
  createdUser: boolean;
}

export interface SsoLoginParams {
  code: string;
  state: string;
}

export interface QuickbooksLoginParams {
  authCode: string;
  state: string;
  realmId: string;
}

export interface QuickbooksLoginResponse {
  success: boolean;
}

export interface CheckHasLinkToQuickBooksResponse {
  hasLinked: boolean;
}

export interface CheckHasLinkToQuickBooksRequest {
  orgId: number;
}

export interface SsoLoginResponse {
  token: string | null;
  errorType: string | null;
  claims: {
    name: string;
    email: string;
  };
}

export interface ApplyAccessRequest {
  email: string;
  name: string;
  division?: string;
}

export interface SelfRegisterRequest {
  email: string;
  name: string;
  division: string;
  code?: string | null;
}

export type Theme = 'default' | 'org1';

export interface ThemeObject {
  primaryColor: string;
}
export interface User {
  exp: number;
  firstName: string;
  jti: string;
  lastName: string;
  orgId: number;
  orgName: string;
  siteRole: SiteRoleEnum;
  platformRole: PlatformRoleEnum;
  sub: string;
  userFullName: string;
  network: string[] | undefined;
  userId: 1;
  manageOrgs: Organization[];
  defaultAddress?: ContactAddress;
  email: string;
  defaultContactId: number;
  allowSwitchToSourcer: boolean;
  allowSwitchToSupplier: boolean;
  allowAdjustJob: boolean;
  isSsoUser?: boolean;
  hasLinkedToQuickBooks?: boolean;
  canvaUserId?: string;
}

export interface Paged<T> {
  content: T[];
  pageable: Pageable;
  totalElements: number;
  numberOfElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  empty: boolean;
}

export interface Pageable {
  sort: Sort;
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
}

export interface Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface PageParam {
  currentPage: number; // 1-based page number
  pageSize?: number;
}

export type SortOrder = 'asc' | 'desc';

export interface SortParam {
  field: string; // backend entity property name
  order: SortOrder;
}

export type TreeShaped<T> = T & { children?: T[] };

export type CodeName = {
  code: string;
  name: string;
};

export type ValueName = {
  value: number;
  name: string;
};

export enum FilterOperatorEnum {
  ANY = 'ANY',
  BETWEENS = 'BETWEENS ',
  CONTAINS = 'CONTAINS',
  EQUALS = 'EQUALS',
  EXISTS = 'EXISTS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  IN = 'IN',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_EXISTS = 'NOT_EXISTS',
  NOT_IN = 'NOT_IN',
  STARTS_WITH = 'STARTS_WITH',
}

export enum EventType {
  PING = 'PING',
  NOTIFICATION = 'NOTIFICATION',
  WORKSPACE_COUNT = 'WORKSPACE_COUNT',
  JOB = 'JOB',
}

export type FilterCriteriaItem = {
  operator: FilterOperatorEnum;
  values: (string | number | boolean)[];
};

export interface FilterObj {
  id?: FilterCriteriaItem;
}

export enum ExportReportType {
  COMMON = 'COMMON',
  PIPELINE = 'PIPELINE',
  TRANSACTION = 'TRANSACTION',
}
